import { Decimal } from 'decimal.js';
/**
 * Fuel money rules (docs/rebuild/fuel.md section 2).
 *
 * - Amounts, prices and fractional quantities have five decimal places
 *   (owner decision D14, 4 October 2026; the legacy columns had four).
 * - Rounding is half away from zero (the legacy MySQL behaviour), applied
 *   once at the end of a calculation.
 * - A private Decimal clone is used so the global configuration of an app
 *   (for example banker's rounding in the template utilities) never changes
 *   these results.
 */
export const FuelDecimal = Decimal.clone({
    precision: 40,
    rounding: Decimal.ROUND_HALF_UP,
    toExpNeg: -40,
    toExpPos: 40,
});
/** Money, prices and fractional quantities: five decimal places (D14). */
export const FUEL_MONEY_SCALE = 5;
/** Category fractions (legacy `name_as_number`): five decimal places (D14). */
export const FUEL_FRACTION_SCALE = 5;
export function dec(value) {
    const text = typeof value === 'string' ? value : value.toString();
    let result;
    try {
        result = new FuelDecimal(text.trim());
    }
    catch (cause) {
        throw new TypeError(`Not a finite decimal value: ${text}`, { cause });
    }
    if (!result.isFinite())
        throw new TypeError(`Not a finite decimal value: ${text}`);
    return result;
}
/** Rounds to five decimals, half away from zero. */
export function roundMoney(value) {
    return dec(value).toDecimalPlaces(FUEL_MONEY_SCALE, FuelDecimal.ROUND_HALF_UP);
}
/** The wire format: a fixed five-decimal string with no exponent. */
export function formatMoney(value) {
    return roundMoney(value).toFixed(FUEL_MONEY_SCALE);
}
/**
 * A quantity (fractional jerrycans, إلا جركل) on the wire: rounded to five
 * decimals but shown without trailing zeros (fuel.md section 3, decision D14),
 * unlike money, which is always five decimals.
 */
export function formatQuantity(value) {
    return roundMoney(value).toFixed();
}
export function sumMoney(values) {
    return roundMoney(values.reduce((sum, v) => sum.plus(dec(v)), new FuelDecimal(0)));
}
//# sourceMappingURL=money.js.map